module.exports = __webpack_public_path__ + "img/hk-logo.ae3887b4.jpeg";